import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
// import "highlight.js/styles/github.css";
import "highlight.js/styles/atom-one-dark.css";
import "../../assets/editor.css";
import ImageUpload from "../../utils/ImageUpload";
import { createPostApiAsync,categoryListApiAsync } from "../../api/api";


const MarkdownTestInput = () => {
    const [options, setOptions] = useState([]);
    const [markdown, setMarkdown] = useState('');
    const [showSeoFields, setShowSeoFields] = useState(false);
    const [formData, setFormData] = useState({
        'Title': '',
        'Content': '',
        'LanguageType': 0,
        'CategoryId': 0,
        'CategoryName': '',
        'SystemType': '',
        
        // SEO 相關欄位
        'MetaDescription': '',
        'MetaKeywords': '',
        'CanonicalUrl': '',
        'RobotsTag': 'index,follow',
        
        // Open Graph
        'OgTitle': '',
        'OgDescription': '',
        'OgImage': '',
        'OgType': 'article',
        'OgSiteName': '',
        
        // Twitter Cards
        'TwitterCard': 'summary_large_image',
        'TwitterTitle': '',
        'TwitterDescription': '',
        'TwitterImage': '',
        
        // 文章特定
        'Author': '',
        'PublishedTime': '',
        'ModifiedTime': '',
        'ArticleSection': '',
        'ArticleTags': '',
        
        // 結構化數據
        'SchemaMarkup': '',
        'SeoSlug': '',
        'FocusKeyword': ''
    });

    // 模擬從資料庫加載數據
    useEffect(() => {
        const fetchData = async () => {
            // const dbOptions = await new Promise((resolve) =>
            //     setTimeout(() => resolve([
            //         {'CategoryName': 'Option 1','CategoryId' : 1},{'CategoryName': 'Option 2','CategoryId' : 2} , {'CategoryName': 'Option 3','CategoryId' : 3}
            //     ]), 1000)
            // );

           await categoryListApiAsync().then((response) => {
                console.log(response);
                setOptions(response);
           });
            
        };
        fetchData();
    }, []);

     // 處理選擇變化
  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

    const handleSubmit = async () => {
        formData.Content = markdown;
        // console.log(formData);
        await createPostApiAsync(formData)
            .then((response) => {
                alert("success");
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === "LanguageType" || name === "CategoryId" ? Number(value) : value, // 強制將數字字段轉為數字
        });
    };

    const handleMarkdownChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setMarkdown(e.target.value);
    }

    const customRenderers = {
        img: ({ src, alt }) => (
            <img
                src={src}
                alt={alt}
                style={{
                    maxWidth: "100%",
                    height: "auto",
                    cursor: "pointer",
                }}
                onClick={() => window.open(src, "_blank")}
            />
        ),
    };

    return (
        <div className="container content-wrapper" style={{ marginBottom: "100px" }}>
            <div className="row">
                <div className="col-lg-9 mx-auto">
                    <button onClick={handleSubmit} className="btn btn-primary" style={{ marginBottom: "20px" }}>Submit</button>
                    
                    <div className="content-main">
                        {/* 基本欄位 */}
                        <div>標題</div>
                        <input name="Title" type="text" style={{ width: "700px", marginBottom: "20px" }} value={formData.Title || ''} onChange={handleChange} />
                        
                        <div>語言</div>
                        <input name="LanguageType" type="number" style={{ width: "700px", marginBottom: "20px" }} value={formData.LanguageType || ''} onChange={handleChange} />                        
                        
                        <div>系統類型</div>
                        <input name="SystemType" type="text" style={{ width: "700px", marginBottom: "20px" }} value={formData.SystemType || ''} onChange={handleChange} placeholder="請輸入系統類型" />
                        
                        <div>分類</div>
                        <input name="CategoryName" type="text" style={{ width: "700px", marginBottom: "20px" }} value={formData.CategoryName || ''} onChange={handleChange} />

                        <select id="dynamic-select" name="CategoryId" value={formData.CategoryId} onChange={handleSelectChange} style={{ width: "700px", marginBottom: "20px" }}>
                            <option value=''>
                                請選擇
                            </option>
                            {options.map((option) => (
                                <option key={option.categoryId} value={option.categoryId}>
                                    {option.categoryName}
                                </option>
                            ))}
                        </select>

                        <div>內容</div>
                        <textarea onChange={handleMarkdownChange} name="Content" type="text" rows={8} style={{ width: "700px", marginBottom: "20px" }}></textarea>
                        
                        {/* SEO 設定區塊 */}
                        <div style={{ marginTop: "30px" }}>
                            <button 
                                type="button" 
                                onClick={() => setShowSeoFields(!showSeoFields)}
                                className="btn btn-secondary"
                                style={{ marginBottom: "20px" }}
                            >
                                {showSeoFields ? '隱藏' : '顯示'} SEO 設定
                            </button>
                            
                            {showSeoFields && (
                                <div style={{ border: "1px solid #ddd", padding: "20px", borderRadius: "5px" }}>
                                    <h4>SEO 設定</h4>
                                    
                                    {/* 基礎 SEO */}
                                    <h5>基礎 SEO</h5>
                                    <div>Meta Description (150-160字元)</div>
                                    <textarea name="MetaDescription" style={{ width: "700px", marginBottom: "10px" }} rows={3} value={formData.MetaDescription || ''} onChange={handleChange} placeholder="頁面描述，用於搜尋引擎結果顯示" />
                                    
                                    <div>Meta Keywords (逗號分隔)</div>
                                    <input name="MetaKeywords" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.MetaKeywords || ''} onChange={handleChange} placeholder="關鍵字1,關鍵字2,關鍵字3" />
                                    
                                    <div>Canonical URL</div>
                                    <input name="CanonicalUrl" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.CanonicalUrl || ''} onChange={handleChange} placeholder="https://example.com/article-url" />
                                    
                                    <div>SEO Slug</div>
                                    <input name="SeoSlug" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.SeoSlug || ''} onChange={handleChange} placeholder="article-url-slug" />
                                    
                                    <div>Focus Keyword</div>
                                    <input name="FocusKeyword" type="text" style={{ width: "700px", marginBottom: "20px" }} value={formData.FocusKeyword || ''} onChange={handleChange} placeholder="主要關鍵字" />
                                    
                                    <div>Robots Tag</div>
                                    <input name="RobotsTag" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.RobotsTag || ''} onChange={handleChange} placeholder="index,follow" />
                                    
                                    {/* Open Graph */}
                                    <h5>Open Graph (社群分享)</h5>
                                    <div>OG Title</div>
                                    <input name="OgTitle" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.OgTitle || ''} onChange={handleChange} placeholder="社群分享標題" />
                                    
                                    <div>OG Description</div>
                                    <textarea name="OgDescription" style={{ width: "700px", marginBottom: "10px" }} rows={2} value={formData.OgDescription || ''} onChange={handleChange} placeholder="社群分享描述" />
                                    
                                    <div>OG Image URL</div>
                                    <input name="OgImage" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.OgImage || ''} onChange={handleChange} placeholder="https://example.com/image.jpg" />
                                    
                                    <div>OG Site Name</div>
                                    <input name="OgSiteName" type="text" style={{ width: "700px", marginBottom: "20px" }} value={formData.OgSiteName || ''} onChange={handleChange} placeholder="網站名稱" />
                                    
                                    <div>OG Type</div>
                                    <input name="OgType" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.OgType || ''} onChange={handleChange} placeholder="article" />
                                    
                                    <div>Schema Markup</div>
                                    <textarea name="SchemaMarkup" style={{ width: "700px", marginBottom: "10px" }} rows={3} value={formData.SchemaMarkup || ''} onChange={handleChange} placeholder="結構化數據標記" />
                                    
                                    {/* Twitter Cards */}
                                    <h5>Twitter Cards</h5>
                                    <div>Twitter Title</div>
                                    <input name="TwitterTitle" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.TwitterTitle || ''} onChange={handleChange} placeholder="Twitter分享標題" />
                                    
                                    <div>Twitter Description</div>
                                    <textarea name="TwitterDescription" style={{ width: "700px", marginBottom: "10px" }} rows={2} value={formData.TwitterDescription || ''} onChange={handleChange} placeholder="Twitter分享描述" />
                                    
                                    <div>Twitter Image URL</div>
                                    <input name="TwitterImage" type="text" style={{ width: "700px", marginBottom: "20px" }} value={formData.TwitterImage || ''} onChange={handleChange} placeholder="https://example.com/twitter-image.jpg" />
                                    
                                    {/* 文章特定 */}
                                    <h5>文章資訊</h5>
                                    <div>作者</div>
                                    <input name="Author" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.Author || ''} onChange={handleChange} placeholder="作者名稱" />
                                    
                                    <div>文章分類/主題</div>
                                    <input name="ArticleSection" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.ArticleSection || ''} onChange={handleChange} placeholder="技術文章, 生活分享等" />
                                    
                                    <div>文章標籤 (逗號分隔)</div>
                                    <input name="ArticleTags" type="text" style={{ width: "700px", marginBottom: "10px" }} value={formData.ArticleTags || ''} onChange={handleChange} placeholder="標籤1,標籤2,標籤3" />
                                </div>
                            )}
                        </div>
                        
                        {/* Markdown 預覽 */}
                        <div style={{ marginTop: "30px" }}>
                            <h4>預覽</h4>
                            <ReactMarkdown
                                components={customRenderers}
                                remarkPlugins={[remarkGfm]}
                                rehypePlugins={[rehypeHighlight]}
                            >
                                {markdown}
                            </ReactMarkdown>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <ImageUpload />
                </div>
            </div>
        </div>
    );
};

export default MarkdownTestInput;